// Ctrl/Cmd/Shift/middle clicks keep the anchor's native open-in-new-tab.
export const modifiedClick = (event) =>
  Boolean(
    event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey,
  );

// Surfaces that act as a link but are not anchors mirror the browser: a
// modified click opens a new tab, Alt (a download on a real link) does nothing.
export const openModified = (event, href) => {
  if (event.altKey) return;
  window.open(href, '_blank', 'noopener');
};

// Pointer handlers for such a surface; `href` may be a function of the event
// target so the resolved anchor href can be reused.
export const linkSurface = (href, follow) => {
  const resolve = (event) => (typeof href === 'function' ? href(event) : href);
  return {
    onClick: (event) => {
      if (modifiedClick(event)) openModified(event, resolve(event));
      else follow(event);
    },
    onAuxClick: (event) => {
      if (event.button === 1) openModified(event, resolve(event));
    },
  };
};
